import React from 'react';
import './Details.css';

const details = (props) => {
	return (
		<div class="container-fluid"  id="top-container">
	        <div class="row">
	           <div class="col-md-6 col-sm-6 col-xs-12 text-center col-centered">
	           		<h4 id="details-title">Details</h4>
	           		<img
	           			id="block-architecture"
				        src={require('./demoArchPortrait.001.jpeg')}
				        alt="IoT Sandbox Architecture"
				        title="IoT Demo Block Architecture"
				     />
	           </div> 
	        </div>
  		</div>
	);
}

export default details;